import { render } from "./LikeBtn.vue?vue&type=template&id=74703cd6&scoped=true&ts=true"
import script from "./LikeBtn.vue?vue&type=script&lang=ts"
export * from "./LikeBtn.vue?vue&type=script&lang=ts"

import "./LikeBtn.vue?vue&type=style&index=0&id=74703cd6&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/work_code/global/events_gevents.37games.com/src/resource/guidetro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74703cd6"]])

export default __exports__